module.exports = __webpack_public_path__ + "static/media/sw15.d8c235ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/street wear/sw15.jpg
// module id = 538
// module chunks = 0